// extracted by mini-css-extract-plugin
module.exports = {"ant-form-item":"motorcycles_ant-form-item_22Zm2"};